import React from "react";
import CountUpBox from "./CountUpBox"; // adjust path if needed

const FeatureSection = () => {
  return (
    <section className="feature text-white position-relative z-0 start-0" style={{marginTop: '40px', marginBottom: '40px'}}>
      <div className="overlay z-n1"></div>
      <div className="container">
        <div className="feature-inner">
          {/* Counter Section */}
          <div className="counter text-center border-bottom border-white border-opacity-25">
            <div className="inner-counter mb-7">
              <div className="row">
                <div className="col-lg-3 col-md-3 p-2">
                  <div className="counter-box p-2 border-end border-white border-opacity-25">
                    <CountUpBox end={350} label="Attendees" suffix="+"  />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 p-2">
                  <div className="counter-box p-2 border-end border-white border-opacity-25">
                    <CountUpBox end={24} label="Speakers" suffix="+" />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 p-2">
                  <div className="counter-box p-2 border-end border-white border-opacity-25">
                    <CountUpBox end={250} label="Companies" suffix="+" />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 p-2">
                  <div className="counter-box p-2 border-opacity-25">
                    <CountUpBox end={35} label="Countries" suffix="+" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Feature List Section */}
          <div className="feature-lists pt-8">
            <div className="row g-4">

              {/* Feature Box 1 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-box py-7 px-6 rounded text bg-black bg-opacity-25">
               
                    <div className="feature-box-icon mb-4">
                      <i className="fa fa-address-book text-white bg-pink rounded-circle text-center"></i>
                    </div>
                    <div className="feature-box-info">
                      <h5 className="text-white mb-2">LIVE STREAMING</h5>
                      <small>Access every keynote, fireside chat, and panel from anywhere in the world in real-time.</small>
                    </div>
                
                </div>
              </div>

              {/* Feature Box 2 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-box py-7 px-6 rounded bg-black bg-opacity-25">
              
                    <div className="feature-box-icon mb-4">
                      <i className="fa fa-comments text-white bg-pink rounded-circle text-center"></i>
                    </div>
                    <div className="feature-box-info">
                      <h5 className="text-white mb-2">FIRESIDE CHATS</h5>
                      <small>Intimate discussions with global leaders on AI, data, and the net-zero transition.</small>
                    </div>
                 
                </div>
              </div>

              {/* Feature Box 3 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-box py-7 px-6 rounded bg-black bg-opacity-25">
              
                    <div className="feature-box-icon mb-4">
                      <i className="fa fa-desktop text-white bg-pink rounded-circle text-center"></i>
                    </div>
                    <div className="feature-box-info">
                      <h5 className="text-white mb-2">NETWORKING</h5>
                      <small>Join collaboration hubs to connect with peers, investors, startups, and innovators globally.</small>
                    </div>
              
                </div>
              </div>

              {/* Feature Box 4 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-box py-7 px-6 rounded bg-black bg-opacity-25">
             
                    <div className="feature-box-icon mb-4">
                      <i className="fa fa-cogs text-white bg-pink rounded-circle text-center"></i>
                    </div>
                    <div className="feature-box-info">
                      <h5 className="text-white mb-2">HIGH VALUE LEARNING</h5>
                      <small>Gain exclusive insights into digital transformation, big data, and sustainable energy strategies.</small>
                    </div>
                
                </div>
              </div>

              {/* Feature Box 5 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-box py-7 px-6 rounded bg-black bg-opacity-25">
                
                    <div className="feature-box-icon mb-4">
                      <i className="fa fa-gift text-white bg-pink rounded-circle text-center"></i>
                    </div>
                    <div className="feature-box-info">
                      <h5 className="text-white mb-2">EXCITING GIVEAWAYS</h5>
                      <small>Win access to premium resources, exclusive reports, and surprise event rewards.</small>
                    </div>
             
                </div>
              </div>

              {/* Feature Box 6 */}
              <div className="col-lg-4 col-md-6">
                <div className="feature-box py-7 px-6 rounded bg-black bg-opacity-25">
              
                    <div className="feature-box-icon mb-4">
                      <i className="fa fa-graduation-cap text-white bg-pink rounded-circle text-center"></i>
                    </div>
                    <div className="feature-box-info">
                      <h5 className="text-white mb-2">1-ON-1 SESSIONS</h5>
                      <small>Book private sessions with speakers, mentors, and industry leaders for tailored insights.</small>
                    </div>
             
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      {/* Inline Styles */}
      <style>{`
        .feature .counter-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .feature .counter-box:hover {
          transform: translateY(-5px);
          box-shadow: 0px 8px 20px rgba(0,0,0,0.1);
        }
        .feature .feature-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .feature .feature-box:hover {
          transform: translateY(-5px);
          box-shadow: 0px 8px 20px rgba(0,0,0,0.15);
        }
      `}</style>
    </section>
  );
};

export default FeatureSection;
